import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    Divider,
} from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ContactSection = () => {
    return (
        <Box sx={{ background: "#eef3f8", py: { xs: 6, md: 10 } }}>
            <Container maxWidth="lg">
                <Grid container spacing={5} alignItems="center">

                    {/* 🔹 LEFT SIDE CARD */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box
                            sx={{
                                background: "#fff",
                                borderRadius: "14px",
                                px: 3,
                                py: 4,
                                maxWidth: 340,
                                mx: "auto", // ✅ CENTERED
                                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                            }}
                        >
                            {/* HEADER */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: "20px",
                                        color: "#2b5c9e",
                                    }}
                                >
                                    Contacts
                                </Typography>

                                <KeyboardArrowDownIcon
                                    sx={{ color: "#2b5c9e", fontSize: 22 }}
                                />
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            {/* ITEM STYLE */}
                            {[
                                {
                                    icon: <LocationOnOutlinedIcon />,
                                    label: "Adress :",
                                    value:
                                        "#78, Nishanth shelters, Hosur main road, Madiwala, Blore 68. (Next to The Grand Krishna Hotel)",
                                },
                                {
                                    icon: <PhoneOutlinedIcon />,
                                    label: "Phone :",
                                    value: "9535681900 / 7019927779",
                                },
                                {
                                    icon: <MailOutlineOutlinedIcon />,
                                    label: "Mail :",
                                    value: "sudarshanholidays101@gmail.com",
                                },
                                {
                                    icon: <LanguageOutlinedIcon />,
                                    label: "Website :",
                                    value: "https://sudarshanholiday.com/",
                                },
                            ].map((item, i) => (
                                <Box key={i}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 2,
                                            alignItems: "flex-start",
                                            py: 1.5,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 34,
                                                height: 34,
                                                borderRadius: "8px",
                                                background: "#f3f6fb",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#2b5c9e",
                                            }}
                                        >
                                            {item.icon}
                                        </Box>

                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                color: "#8c96a5",
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            <strong style={{ color: "#6b7a90" }}>
                                                {item.label}
                                            </strong>{" "}
                                            {item.value}
                                        </Typography>
                                    </Box>

                                    {i !== 3 && <Divider />}
                                </Box>
                            ))}
                        </Box>
                    </Grid>

                    {/* 🔹 RIGHT SIDE MAP CARD */}
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Box
                            sx={{
                                background: "#fff", // ✅ CARD BG AROUND MAP
                                p: 2,
                                borderRadius: "14px",
                                boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                            }}
                        >
                            <Box
                                sx={{
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                }}
                            >
                                <iframe
                                    title="map"
                                    src="https://www.google.com/maps?q=Sudarshan+Travels+%26+Holidays+Bangalore&output=embed"
                                    width="100%"
                                    height="420"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                />
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </Container>
        </Box>
    );
};

export default ContactSection;